import { BehaviorSubject } from 'rxjs'

import { FuelLayer } from '@/domain/protocols/Fuel'

interface RegisterPriceFuelForm {
  type: 'register-price'
  adhpCode: string
  fuelType: FuelLayer
  providerOptions: string[]
}

interface RegisterProviderFuelForm {
  type: 'register-provider'
  source: 'fuel-tool' | 'fuel-feature-info'
  adhpCode?: string
  initialLayer?: FuelLayer
}

interface EditProviderFuelForm {
  type: 'edit-provider'
  adhpCode: string
  provider: string
  initialLayer: FuelLayer
}

type FuelFormType = RegisterPriceFuelForm | RegisterProviderFuelForm | EditProviderFuelForm

export interface FuelFormStateProps {
  active: FuelFormType | null
}

const INITIAL_STATE: FuelFormStateProps = {
  active: null
}

export const FuelFormState = new BehaviorSubject<FuelFormStateProps>(INITIAL_STATE)

export const FuelFormStateMutator = {
  mutate: (newState: FuelFormStateProps) => {
    FuelFormState.next(newState)
  },

  showRegisterPrice: (adhpCode: string, fuelType: FuelLayer, providerOptions: string[]) => {
    FuelFormState.next({
      active: {
        type: 'register-price',
        adhpCode,
        fuelType,
        providerOptions
      }
    })
  },

  showRegisterProviderFromTool: () => {
    FuelFormState.next({
      active: {
        type: 'register-provider',
        source: 'fuel-tool'
      }
    })
  },

  showRegisterProviderFromFeatureInfo: (adhpCode: string, initialLayer: FuelLayer) => {
    FuelFormState.next({
      active: {
        type: 'register-provider',
        source: 'fuel-feature-info',
        adhpCode,
        initialLayer
      }
    })
  },

  showEditProvider: (adhpCode: string, provider: string, initialLayer: FuelLayer) => {
    FuelFormState.next({
      active: {
        type: 'edit-provider',
        adhpCode,
        provider,
        initialLayer
      }
    })
  },

  hide: () => {
    FuelFormState.next({
      active: null
    })
  }
}
